import React, { useState, useEffect, useRef } from "react";
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";




const InfoBlock = ({ children }) => {
  return (
      <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.02)" }} >
        {children}
    </div>
  );
};



const PageLoading = () => {

    return <div style={{width: "100%", marginTop: "50px", display: "flex", justifyContent: "center" }}>
        <LoadingSpinnerImage />
    </div>

}


export {
    InfoBlock,
    PageLoading,
}